export default "__VITE_ASSET__aRA0sXUz__"